import { render } from "./HelloWorld.vue?vue&type=template&id=6e95864a&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=6e95864a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e95864a"

export default script